import type { MailItem, MailThreadItem } from '@jerome2/shared';

type LastVerb = MailItem['lastVerb'];

// Beantwoord of doorgestuurd: Outlook onthoudt per mail alleen de laatste handeling (lastVerb).
// In de lezer kijken we ook naar de latere mails van Jeroen zelf in het gesprek, zodat "beantwoord
// én doorgestuurd" allebei zichtbaar zijn.

export interface MailVerbs {
  replied: string | null;
  forwarded: string | null;
}

const FORWARD_SUBJECT = /^\s*(fw|fwd|doorst\.?|wg|tr)\s*:/i;

/** Uit de laatste handeling van Outlook (lijst) en, als die er zijn, de latere eigen mails in het gesprek (lezer). */
export function mailVerbs(m: { lastVerb: LastVerb; lastVerbAt: string | null }, later: MailThreadItem[] = []): MailVerbs {
  let replied: string | null = m.lastVerb === 'reply' || m.lastVerb === 'replyAll' ? (m.lastVerbAt ?? '') : null;
  let forwarded: string | null = m.lastVerb === 'forward' ? (m.lastVerbAt ?? '') : null;
  for (const t of later) {
    if (!t.fromMe) continue;
    const at = t.received ?? '';
    if (FORWARD_SUBJECT.test(t.subject)) forwarded = forwarded === null || (forwarded !== '' && at > forwarded) ? at : forwarded;
    else replied = replied === null || (replied !== '' && at > replied) ? at : replied;
  }
  return { replied, forwarded };
}

/** Korte tekst voor een tooltip of de kop van de lezer: "beantwoord en doorgestuurd". */
export function describeVerbs(v: MailVerbs): string | null {
  const parts = [v.replied !== null ? 'beantwoord' : '', v.forwarded !== null ? 'doorgestuurd' : ''].filter(Boolean);
  return parts.length ? parts.join(' en ') : null;
}
